module.exports = __webpack_public_path__ + "img/mtablet.2932138d.png";